import CheckCircleOutlineIcon from "@atlaskit/icon/glyph/check-circle-outline";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import Spinner from "@atlaskit/spinner";
import { token } from "@atlaskit/tokens";

import { FormattedMessageProps } from "../../messages";

export const IsValidOrLoading = ({
    isValidating,
    siteNameValue,
    validationMessage
}: {
    isValidating: boolean;
    siteNameValue: string;
    validationMessage?: FormattedMessageProps;
}) => {
    if (siteNameValue === "") {
        return null;
    }
    if (isValidating) {
        return <Spinner size="small" testId="spinner" />;
    }
    if (validationMessage) {
        return (
            <WarningIcon
                label="warning"
                primaryColor={token("color.border.danger")}
            />
        );
    }
    return (
        <CheckCircleOutlineIcon
            label="success"
            primaryColor={token("color.border.success")}
        />
    );
};
